<template>
  <div class="animated fadeIn">
          <div class="table-responsive pt-2" v-if="phones && phones.length > 0">
            <table class="table table-hover" style="'border: 1px solid #dcdede;'">
              <thead class="thead-third" style="border: solid 1px #04a791;">
                <tr>
                  <th class="text-center" style="font-size: 10px;">CONTATO</th>
                  <th class="text-center" style="font-size: 10px;">TIPO</th>
                  <th class="text-center" style="font-size: 10px;">AÇÃO</th>
                </tr>
              </thead>
              <tbody v-if="phones && phones.length > 0">
                <tr v-for="(obj, index) in phones" :key="index">
                  <td class="text-center"><a :href="`tel:${obj.telefone}`">{{obj.telefone}}</a></td>
                  <td class="text-center" style="font-size: 11px;">{{obj.tipoContato}}</td>
                  <td @click="toastInfo" class="text-center" style="font-size: 14px; cursor: pointer;"><i :class="obj.tipoContato === 'CELULAR' ? 'fab fa-whatsapp' : 'fas fa-phone-alt'"></i></td>
                </tr>
                <tr v-if="card.pessoa.email">
                  <td class="text-center"><a :href="`mailto:${card.pessoa.email}`">{{card.pessoa.email}}</a></td>
                  <td class="text-center" style="font-size: 11px;">E-MAIL</td>
                  <td @click="toastInfo" class="text-center" style="font-size: 14px; cursor: pointer;"><i class="fas fa-mail-bulk"></i></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="text-center">{{$lang.Common.DataTable.NoRecordsFound}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Nenhum registro de contato, <strong @click="onAddPhone" style="cursor: pointer">clique para adicionar</strong>
          </div>
    <ModalAddPhone ref="ModalAddPhone" :card="card" v-on:Reload="onReload"/>
  </div>
</template>
<script>
import CrmDetailsContacts from './contact.js'
export default CrmDetailsContacts
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/contacts/Contact.vue